import React, { useState } from "react"
import Svg from "../_svgs/svg"

export default function ManageBookingShortcutComponent({
  bookingNumberLabel,
  bookingNumberPlaceholder,
  findBookingButtonText,
  forgotBookingNumberLink,
  forgotBookingNumberLinkText,
  forgotBookingNumberLinkTitle,
  forgotBookingNumberText,
  mailInputLabel,
  mailInputPlaceholder,
  lang,
}) {
  const [emailInput, setEmailInput] = useState("")
  const [reservationInput, setReservationInput] = useState("")

  let constructedUrl =
    lang == "da"
      ? `${document.location.protocol}//${document.location.hostname}/parkering/manage/search?email=${emailInput}&reference=${reservationInput}`
      : `${document.location.protocol}//${document.location.hostname}/en/parkering/manage/search?email=${emailInput}&reference=${reservationInput}`

  return (
    <section className={"manage-booking-shortcut-component-container w--wider"}>
      <div className="input-form">
        <div className="input-outer-container">
          <div className="input-container">
            <label className="input-label" htmlFor="manage-shortcut-email">
              {mailInputPlaceholder}
            </label>
            <input
              className="input-field"
              aria-describedby="manage-shortcut-email-helptext"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              id="manage-shortcut-email"
              type="email"
            ></input>
            <span aria-hidden="true" tabIndex={-1} className="input-helptext" id="manage-shortcut-email-helptext">
              {mailInputLabel}
            </span>
          </div>
          <div className="input-container">
            <label className="input-label" htmlFor="manage-shortcut-reservation">
              {bookingNumberPlaceholder}
            </label>
            <input
              className="input-field"
              aria-describedby="manage-shortcut-reservation-helptext"
              id="manage-shortcut-reservation"
              type="text"
              value={reservationInput}
              onChange={(e) => setReservationInput(e.target.value)}
            ></input>
            <span aria-hidden="true" tabIndex={-1} className="input-helptext" id="manage-shortcut-reservation-helptext">
              {bookingNumberLabel}
            </span>
          </div>
        </div>
        <a href={constructedUrl} className="redirect-button">
          {findBookingButtonText}
        </a>
      </div>
      <div className="forgot-reservation-container">
        <p className="forgot-reservation-header">{forgotBookingNumberText}</p>
        <a href={forgotBookingNumberLink} title={forgotBookingNumberLinkTitle} className="link-with-arrow-container">
          <span>
            <Svg iconName="arrowright-slim"></Svg>
          </span>
          <p>{forgotBookingNumberLinkText}</p>
        </a>
      </div>
    </section>
  )
}
